package at.apa.statistictracker.logger

object Logger {
    private const val LIBRARY_TAG = "ApaStatisticsTracker"

    private var platformLogger = PlatformLogger()

    var enabled
        get() = platformLogger.enabled
        set(value) {
            platformLogger.enabled = value
        }

    fun v(tag: String, message: String) {
        if (platformLogger.enabled) {
            platformLogger.v(tag, "$LIBRARY_TAG -> $message")
        }
    }

    fun d(tag: String, message: String) {
        if (enabled) {
            platformLogger.d(tag, "$LIBRARY_TAG -> $message")
        }
    }

    fun i(tag: String, message: String) {
        if (enabled) {
            platformLogger.i(tag, "$LIBRARY_TAG -> $message")
        }
    }

    fun w(tag: String, message: String) {
        if (enabled) {
            platformLogger.w(tag, "$LIBRARY_TAG -> $message")
        }
    }

    fun e(tag: String, message: String) {
        if (enabled) {
            platformLogger.e(tag, "$LIBRARY_TAG -> $message")
        }
    }

    fun e(tag: String, message: String, throwable: Throwable) {
        if (enabled) {
            platformLogger.e(tag, message, throwable)
        }
    }

}

internal expect class PlatformLogger() {
    var enabled: Boolean

    fun v(tag: String, message: String)
    fun d(tag: String, message: String)
    fun i(tag: String, message: String)
    fun w(tag: String, message: String)
    fun e(tag: String, message: String)
    fun e(tag: String, message: String, throwable: Throwable)
}

